/** @jsx jsx */
import { jsx } from 'theme-ui';
import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';

/**
 * A form controlled by formik.
 * @param {*} props The props for formik.
 */
export default function ControlledForm({
  initialValues,
  validationSchema,
  onSubmit,
  children,
  name,
  ...rest
}) {
  return (
    <Formik
      initialValues={{ 'form-name': name, ...initialValues }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      render={({ handleSubmit, handleReset }) => (
        <Form
          noValidate
          onSubmit={handleSubmit}
          onReset={handleReset}
          data-netlify
          netlify-honeypot="honey-pot"
          name={name}
        >
          <input type="hidden" name="honey-pot" />
          {children}
        </Form>
      )}
      {...rest}
    />
  );
}
